import { render, staticRenderFns } from "./SoaSignGuard.vue?vue&type=template&id=523c059a&lang=pug"
import script from "./SoaSignGuard.vue?vue&type=script&lang=js"
export * from "./SoaSignGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports